/**
 * Created by shobhitjain on 09/01/20.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './index.scss';

class TabView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultIndex: this.props.defaultIndex,
      activeIndex: this.props.defaultIndex
    };
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('hashchange', this.handleHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.defaultIndex !== nextProps.defaultIndex) {
      this.setState({
        defaultIndex: nextProps.defaultIndex,
        activeIndex: nextProps.defaultIndex
      });
    }
  }

  setActiveIndex = (index) => {
    this.setState({ activeIndex: index });
    this.props.onTabSelect(index);
  };

  handleHashChange = (e) => {
    const hashValue = decodeURI(window.location.hash);
    const match = hashValue.match(/#section(\d+)/);
    if (match) {
      const newIndex = Number(match[1]);
      this.setActiveIndex(newIndex);
    }
  };
  render() {
    const { activeIndex } = this.state;
    const { tabList } = this.props;

    return (
      <div className={style.container}>
        <ul
          className={classnames('nav', 'nav-tabs', style.nav_tabs_tookitaki)}
          id="myTab">
          {tabList.map((tab, index) => {
            // todo fix this with proper solution
            if (index <= 11) {
              const anchor = '#section' + index;
              return (
                <li
                  key={index}
                  onClick={() => this.setActiveIndex(index)}
                  className={classnames(style.nav_tab_item)}>
                  <a
                    href={anchor}
                    className={classnames(
                      style.nav_tab_link,
                      activeIndex === index ? style.nav_tab_link_active : ''
                    )}>
                    {tab}
                  </a>
                </li>
              );
            }
            return (
              <li
                key={index}
                onClick={() => {}}
                className={classnames(style.nav_tab_item)}>
                <a
                  className={classnames(
                    style.nav_tab_link,
                    style.nav_tab_link_disabled
                  )}>
                  {tab}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

TabView.propTypes = {
  tabList: PropTypes.array.isRequired,
  defaultIndex: PropTypes.number
};

TabView.defaultProps = {
  defaultIndex: 0,
  onTabSelect: () => {}
};

export default TabView;
